<div class="cre-commitment-container" (click)="onCommitmentSelected()">
  <div class="cre-commitment-container-icon">
    <fa-icon [icon]="iconConfiguration"></fa-icon>
  </div>
  <div *ngIf="!isConfiguration">
    <div class="cre-commitment-container-checkbox-unchecked" *ngIf="!isCompleted"></div>
  </div>
  <fa-icon class="cre-commitment-container-edit" [icon]="['fal', 'pencil-alt']" *ngIf="canEdit">
  </fa-icon>
  <fa-icon class="cre-commitment-container-checkbox-checked" [icon]="['fas', 'check']" *ngIf="isCompleted">
  </fa-icon>
  <div class="cre-commitment-container-label">{{ label }}</div>
  <div class="cre-commitment-container-description">{{ description }} </div>
</div>
